module.exports = __webpack_public_path__ + "static/media/icon-upvote-filled.af61fa41.svg";